import { render, staticRenderFns } from "./GastosViaje.vue?vue&type=template&id=3e4d5b8e&"
import script from "./GastosViaje.vue?vue&type=script&lang=js&"
export * from "./GastosViaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GastosViaje.vue"
export default component.exports